module.exports = __webpack_public_path__ + "static/media/BB-Snake_eight.d0c0c8df.png";